<template>
    <table class="table table-hover" style="min-width: 780px">
        <thead>
            <tr>
                <th scope="col">Hotel</th>
                <th scope="col">Check-in</th>
                <th scope="col">Check-out</th>
                <th scope="col">Nights</th>
                <th scope="col">Destination</th>
                <th scope="col">Price</th>
                <th scope="col" class="text-right">Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in data" :key="item.id">
                <td><a class="link-style" target="_blank" :href="'/quote/'+(item.id || '')+'.pdf'">{{ item.hotel ? item.hotel.name || 'N/A' : 'N/A' }}</a></td>
                <td>
                    <span v-if="item.min_checkin">{{ [ item.min_checkin, "MM/DD/YYYY" ] | moment("MMM D, YYYY") }}</span>
                    <span v-if="!item.min_checkin">-</span>
                </td>
                <td>
                    <span v-if="item.max_checkout">{{ [ item.max_checkout, "MM/DD/YYYY" ] | moment("MMM D, YYYY") }}</span>
                    <span v-if="!item.max_checkout">-</span>
                </td>
                <td>{{ item.nights !== undefined ? item.nights : 'N/A' }}</td>
                <td>{{ item.hotel && item.hotel.destination ? item.hotel.destination.name || 'N/A' : 'N/A' }}</td>
                <td>{{ item.total_price !== undefined ? item.total_price : 0 | currency }}</td>
                <td class="text-right">
                    <a class="d-inline-block" target="_blank" :href="'/quote/'+(item.id || '')+'.pdf'"><i class="material-icons">visibility</i></a>
                </td>
            </tr>
            <tr v-if="data.length === 0">
                <td colspan="7"><p class="h4">Ooops... sorry, we did not find any records.</p></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                default() { return []; }
            },
        },
    }
</script>
